export const textColorThemes = [
  { 
    id: 'slate', 
    name: 'Slate & Indigo', 
    main: '#1e293b', 
    accent: '#6366f1',
    description: 'Professional and modern'
  },
  { 
    id: 'white', 
    name: 'Pure & Sky', 
    main: '#ffffff', 
    accent: '#38bdf8',
    description: 'Clean and airy'
  },
  { 
    id: 'gold', 
    name: 'Deep & Gold', 
    main: '#1a1a1a', 
    accent: '#fbbf24',
    description: 'Luxury and prestige'
  },
  { 
    id: 'rose', 
    name: 'Midnight & Rose', 
    main: '#0f172a', 
    accent: '#fb7185',
    description: 'Bold and elegant'
  },
  { 
    id: 'emerald', 
    name: 'Forest & Lime', 
    main: '#064e3b', 
    accent: '#a3e635',
    description: 'Natural and vibrant'
  },
  { 
    id: 'cyber', 
    name: 'Cyan & Pink', 
    main: '#0891b2', 
    accent: '#db2777',
    description: 'Futuristic and loud'
  },
  { 
    id: 'minimal', 
    name: 'Monochrome', 
    main: '#000000', 
    accent: '#71717a',
    description: 'Absolute simplicity'
  },
  { 
    id: 'sunset', 
    name: 'Plum & Orange', 
    main: '#4c1d95', 
    accent: '#f97316',
    description: 'Warm and creative'
  }
];